(function () {
  'use strict';

  var routes = window.routes || {};
  var strings = window.cartStrings || {};

  /* -------------------------------------------------
     Header: cart count + mobile nav
     ------------------------------------------------- */

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.closest('[data-cart-link]')?.setAttribute('data-count', count);
    });
  }

  function refreshCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }

  var nav = document.querySelector('[data-mobile-nav]');
  var navToggle = document.querySelector('[data-mobile-nav-toggle]');
  if (nav && navToggle) {
    navToggle.addEventListener('click', function () {
      var open = document.documentElement.classList.toggle('mobile-nav-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.documentElement.classList.remove('mobile-nav-open');
        navToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* -------------------------------------------------
     AJAX add to cart
     ------------------------------------------------- */

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[data-product-form]')) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var original = button ? button.innerHTML : '';
    if (button) { button.setAttribute('disabled', 'disabled'); }

    var formData = new FormData(form);
    formData.append('sections_url', window.location.pathname);

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          showFormError(form, data.description || strings.error);
          return;
        }
        refreshCart();
        if (button) {
          button.innerHTML = strings.added || 'Added';
          setTimeout(function () { button.innerHTML = original; button.removeAttribute('disabled'); }, 2000);
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        showFormError(form, strings.error);
        if (button) { button.removeAttribute('disabled'); button.innerHTML = original; }
      });
  });

  function showFormError(form, message) {
    var target = form.querySelector('[data-form-error]');
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  }

  /* -------------------------------------------------
     Collection: load more (progressive enhancement)
     ------------------------------------------------- */

  var loadMoreWrap = document.querySelector('[data-load-more]');
  if (loadMoreWrap) {
    loadMoreWrap.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-load-more-button]');
      if (!link) return;
      event.preventDefault();
      var url = link.getAttribute('href');
      link.setAttribute('aria-busy', 'true');

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll('[data-product-grid] > *');
          var grid = document.querySelector('[data-product-grid]');
          newItems.forEach(function (node) { grid.appendChild(node); });

          var newPager = doc.querySelector('[data-load-more]');
          if (newPager && newPager.querySelector('a[data-load-more-button]')) {
            loadMoreWrap.innerHTML = newPager.innerHTML;
          } else {
            loadMoreWrap.remove();
          }
        });
    });
  }

  /* -------------------------------------------------
     Collection: product search (client-side title filter)
     ------------------------------------------------- */

  (function () {
    var searchWrap = document.querySelector('[data-product-search]');
    var grid = document.querySelector('[data-product-grid]');
    if (!searchWrap || !grid) return;

    var input = searchWrap.querySelector('[data-product-search-input]');
    var clearBtn = searchWrap.querySelector('[data-product-search-clear]');
    var noResults = document.querySelector('[data-no-results]');
    if (!input) return;

    var fullyLoaded = false;
    var fetching = false;
    var debounce;
    var PAGE_LIMIT = 40;
    var pagesFetched = 0;

    function pager() { return document.querySelector('[data-load-more]'); }

    function query() { return (input.value || '').trim().toLowerCase(); }

    function titleOf(card) {
      var el = card.querySelector('.product-card__title');
      return el ? el.textContent.trim().toLowerCase() : '';
    }

    function apply() {
      var q = query();
      if (clearBtn) clearBtn.hidden = q === '';

      var matches = 0;
      grid.querySelectorAll(':scope > .product-card').forEach(function (card) {
        var show = q === '' || titleOf(card).indexOf(q) !== -1;
        card.hidden = !show;
        if (show) matches += 1;
      });

      var p = pager();
      if (p) p.hidden = q !== '';
      if (noResults) noResults.hidden = !(q !== '' && matches === 0 && fullyLoaded);
    }

    function loadRest() {
      if (fetching || fullyLoaded) return;
      var p = pager();
      var next = p && p.querySelector('a[data-load-more-button]');
      if (!next || pagesFetched >= PAGE_LIMIT) { fullyLoaded = true; apply(); return; }

      fetching = true;
      fetch(next.getAttribute('href'), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('[data-product-grid] > *').forEach(function (node) {
            grid.appendChild(node);
          });
          pagesFetched += 1;
          var newPager = doc.querySelector('[data-load-more]');
          if (newPager && newPager.querySelector('a[data-load-more-button]')) {
            p.innerHTML = newPager.innerHTML;
          } else {
            fullyLoaded = true;
            if (p) p.remove();
          }
          fetching = false;
          apply();
          if (!fullyLoaded && query() !== '') loadRest();
        })
        .catch(function () { fetching = false; });
    }

    // If the collection fits on one page there is nothing left to fetch.
    fullyLoaded = !pager();

    input.addEventListener('input', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        apply();
        if (query() !== '') loadRest();
      }, 180);
    });

    input.addEventListener('search', apply);

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        apply();
        input.focus();
      });
    }
  })();

  /* -------------------------------------------------
     Product gallery: thumbnail switching
     ------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;

    var gallery = thumb.closest('[data-product-gallery]');
    if (!gallery) return;

    var main = gallery.querySelector('[data-gallery-main] img');
    var full = thumb.getAttribute('data-full');

    if (main && full) {
      // The main <img> carries srcset/sizes; the browser picks the displayed
      // image from those and treats src as a fallback, so clear them before
      // swapping the source.
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = full;
      main.setAttribute('alt', thumb.getAttribute('data-alt') || '');
    }

    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.removeAttribute('aria-current');
    });
    thumb.setAttribute('aria-current', 'true');
  });

  /* -------------------------------------------------
     Variant selection on product page
     ------------------------------------------------- */

  document.querySelectorAll('[data-variant-selects]').forEach(function (root) {
    var form = root.closest('form[data-product-form]');
    if (!form) return;
    var priceTarget = document.querySelector('[data-product-price] .price');
    var buttonText = form.querySelector('[data-add-button-text]');
    var idInput = form.querySelector('input[name="id"]');
    var dataEl = root.querySelector('[data-variant-data]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }

    root.addEventListener('change', function () {
      var selected = Array.prototype.map.call(root.querySelectorAll('select'), function (el) { return el.value; });
      var match = variants.find(function (v) { return v.options.join(' / ') === selected.join(' / '); });
      var button = form.querySelector('[type="submit"]');
      if (!match) {
        if (button) { button.setAttribute('disabled', 'disabled'); }
        if (buttonText) { buttonText.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceTarget && match.price_html) priceTarget.textContent = match.price_html;
      if (button) {
        button.toggleAttribute('disabled', !match.available);
        if (buttonText) buttonText.textContent = match.available ? match.add_label : 'Sold out';
      }
    });
  });

  /* -------------------------------------------------
     Related products (recommendations API)
     ------------------------------------------------- */

  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var incoming = doc.querySelector('[data-recommendations]');
        if (incoming && incoming.innerHTML.trim().length) {
          el.innerHTML = incoming.innerHTML;
        } else {
          el.closest('[data-recommendations-section]')?.remove();
        }
      });
  });

  /* -------------------------------------------------
     Newsletter inline feedback
     ------------------------------------------------- */

  var params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true') {
    document.querySelectorAll('[data-newsletter-success]').forEach(function (el) { el.hidden = false; });
  }
})();
